import { Toaster } from "components/notification/Toaster";
import { func_serviceHandling, isNumberValid } from "functions";
import { useDispatch } from "react-redux";
import { getActivityLog_failure, getActivityLog_request, getActivityLog_success, getModuleNames_failure, getModuleNames_request, getModuleNames_success } from "../slices/logging.slices";
import usePromiseInstance_authorization from "./config";

export default function useLogging() {
    const dispatch = useDispatch();
    const request = usePromiseInstance_authorization();

    function getActivityLog(pageNo, pageSize, sort, filterOptions = {}) {
        let isOffsetValid = isNumberValid(pageNo) && isNumberValid(pageSize);
		let offset = isOffsetValid? pageNo * pageSize:0;

		let paramObj = {
			offset: offset,
			limit: pageSize,
			sort: sort,
			role: "Dealer",
			...filterOptions
		}

		let url = func_serviceHandling.createUrlWithParams('/General/GetActivityLog', paramObj)

        dispatch(getActivityLog_request());

        request(getActivityLog_request, (axios) => {    
            axios.get(url)
                .then((response) => {
                    dispatch(getActivityLog_success(response));
                })
                .catch((error) => {
                    dispatch(getActivityLog_failure(error?.response?.data?.exceptionMessage));

                    Toaster({
                        type: "error",
                        msg: error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to get logs" 
                    })
                })
        })
    }

    function getModuleNames() {
        dispatch(getModuleNames_request());

        request(getModuleNames_request, (axios) => {    
            axios.get("/General/GetModuleNames")
                .then((response) => {
                    dispatch(getModuleNames_success(response));
                })
                .catch((error) => {
                    dispatch(getModuleNames_failure(error?.response?.data?.exceptionMessage));

                    Toaster({
                        type: "error",
                        msg: error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to get list of modules"
                    })
                })
        })
    }

    return {
        getActivityLog, getModuleNames
    }
}